import { isLikeNotificationDetails as typeGuard } from "@scrile/api-provider/dist/api/LikeProvider";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";

export { default } from "./NotificationLike.vue";

export const selector = (item: Notification): boolean => {
  return typeGuard(item.details);
};
